import { createSlice } from "@reduxjs/toolkit";

export const generalDetails = createSlice({
  name: "generalDetails",
  initialState: {},
  reducers: {
    setGeneralDetailsData: (_, action) => {
      return action.payload;
    },
  },
});

export const { setGeneralDetailsData } = generalDetails.actions;

export default generalDetails.reducer;
